import { render, staticRenderFns } from "./AdminShellHeader.vue?vue&type=template&id=1f605b92"
import script from "./AdminShellHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminShellHeader.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports